/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
function n(n){return n["data-item"]}function t(n,t){n?.sort(((n,i)=>{const e=t.indexOf(n.uid),r=t.indexOf(i.uid);return e>r?-1:e<r?1:0}))}export{n as getItem,t as sortTablesToIds};
